import React from "react";
import PhoneInputLib from "react-phone-number-input";
import { formatPhoneNumber, formatPhoneNumberIntl, isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./PhoneField.css";

/**
 * Shared phone input — US auto-format, international support, E.164 value.
 * onChange receives the E.164 string (e.g. "+16095550142") or undefined.
 */
export const PhoneField = React.forwardRef(function PhoneField(
  { value, onChange, placeholder = "Phone number", testid, className = "", disabled, defaultCountry = "US", ...rest },
  ref,
) {
  return (
    <div className={`phone-field ${className}`} data-testid={testid ? `${testid}-wrap` : undefined}>
      <PhoneInputLib
        ref={ref}
        defaultCountry={defaultCountry}
        value={value || undefined}
        onChange={(v) => onChange?.(v || "")}
        placeholder={placeholder}
        disabled={disabled}
        numberInputProps={{ "data-testid": testid }}
        {...rest}
      />
    </div>
  );
});

/** Display helper: US → national "(609) 555-0142", else international. */
export function formatPhoneDisplay(e164) {
  if (!e164) return "";
  try {
    const national = formatPhoneNumber(e164);
    return national || formatPhoneNumberIntl(e164) || e164;
  } catch {
    return e164;
  }
}

export { isValidPhoneNumber };
export default PhoneField;
